/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

export const msalConfig = {
    // auth: {
    //     clientId: "b7eb8e6f-884f-4b6f-a9df-63a3cee3c42e",
    //     authority: "https://login.microsoftonline.com/9daadb09-074c-4f78-8102-f06c03518fdf",
    //     redirectUri: "http://localhost:3000",
    // },
    auth :{
        clientId: process.env.REACT_APP_NEXTGEN_CLIENT_ID,
        authority: process.env.REACT_APP_NEXTGEN_AUTHORITYURL,
        redirectUri: process.env.REACT_APP_NEXTGEN_URL,
},
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }
                switch (level) {
                    case LogLevel.Error:
                       
                        return;
                    case LogLevel.Info:
                        
                        return;
                    case LogLevel.Verbose:
                       
                        return;
                    case LogLevel.Warning:
                        
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};



// graph.js


/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken 
 */
export async function callMsGraph(accessToken) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;
    console.log('AccessToken', accessToken)

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(graphConfig.graphMeEndpoint, options)
        .then(response => {return response.json()})
        .catch(error => console.log(error));
}